import { dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, selectColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'business';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    primaryRelationshipColumn({column: 'id', endpoint, required: true}),
    dateColumn({column: 'relocated_date', label: 'Date Relocated', required: true}),
    selectColumn({
        label: 'Relocated',
        column: 'relocated_type',
        options: [
            {label: 'In', value: 'in'},
            {label: 'Out', value: 'out'},
        ],
        required: true,
    }),
];

const RelocatedBusinesses = forwardRef(function RelocatedBusinesses(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {RelocatedBusinesses};
